import TableSortLabelMUI, { TableSortLabelProps } from '@material-ui/core/TableSortLabel';
import React from 'react';

// eslint-disable-next-line react/function-component-definition
export const TableSortLabel: React.FC<TableSortLabelProps> = ({ children, ...rest }) => {
	return <TableSortLabelMUI {...rest}>{children}</TableSortLabelMUI>;
};
